(() => {
  const MAX_TICKETS = 2;
  const FALLBACK_SECTORS = {
    'upper-tier': ['2U', '3U', '4U', '5U', '6U', '7U', '8U', '9U', '10U', '11U'],
    'lower-tier': ['2L', '3L', '4L', '5L', '6L', '7L', '8L', '9L', '10L', '11L'],
    'vip-saturn': ['1U', '12U'],
    'vip-lovely': ['1L', '12L'],
    'vip-sir-duke': ['1L', '12L'],
    'vip-ultimate': ['1L', '12L'],
  };
  const SEAT_LAYOUTS = {
    'upper-tier': { rows: 'ABCDEFGHIJKLM'.split(''), seats: 40 },
    'lower-tier': { rows: 'ABCDEFGHIJKLMN'.split(''), seats: 36 },
    'vip-saturn': { rows: 'ABCDEFGHIJKLM'.split(''), seats: 36 },
    'vip-lovely': { rows: 'FGHIJKLMN'.split(''), seats: 36 },
    'vip-sir-duke': { rows: ['C', 'D', 'E'], seats: 36 },
    'vip-ultimate': { rows: ['A', 'B'], seats: 36 },
  };
  const DISPLAYED_CAPACITY = {
    'upper-tier': { '2U': 391, '3U': 417, '4U': 404, '5U': 395, '6U': 393, '7U': 394, '8U': 396, '9U': 392, '10U': 399, '11U': 398 },
    'lower-tier': { '2L': 386, '3L': 410, '4L': 398, '5L': 398, '6L': 395, '7L': 394, '8L': 403, '9L': 380, '10L': 403, '11L': 408 },
    'vip-saturn': { '1U': 410, '12U': 405 },
    'vip-lovely': { '1L': 269, '12L': 259 },
    'vip-sir-duke': { '1L': 80, '12L': 89 },
    'vip-ultimate': { '1L': 51, '12L': 53 },
  };
  const MAP_SECTOR_PATHS = [
    'M304.9 154.6 A128 128 0 0 1 323 192.7 L292.3 201.5 A96 96 0 0 0 278.6 172.9 Z',
    'M324.2 197 A128 128 0 0 1 327.5 239.2 L295.6 236.4 A96 96 0 0 0 293.1 204.8 Z',
    'M327 243.6 A128 128 0 0 1 315 284.1 L286.3 270.1 A96 96 0 0 0 295.3 239.7 Z',
    'M313 288.1 A128 128 0 0 1 287.3 321.6 L265.5 298.2 A96 96 0 0 0 284.8 273.1 Z',
    'M284 324.6 A128 128 0 0 1 247.9 346.7 L236 317 A96 96 0 0 0 263 300.5 Z',
    'M243.8 348.3 A128 128 0 0 1 202.2 356 L201.7 324 A96 96 0 0 0 232.8 318.2 Z',
    'M197.8 356 A128 128 0 0 1 156.2 348.3 L167.2 318.2 A96 96 0 0 0 198.3 324 Z',
    'M152.1 346.7 A128 128 0 0 1 116 324.6 L137 300.5 A96 96 0 0 0 164 317 Z',
    'M112.7 321.6 A128 128 0 0 1 87 288.1 L115.2 273.1 A96 96 0 0 0 134.5 298.2 Z',
    'M85 284.1 A128 128 0 0 1 73 243.6 L104.7 239.7 A96 96 0 0 0 113.7 270.1 Z',
    'M72.5 239.2 A128 128 0 0 1 75.8 197 L106.9 204.8 A96 96 0 0 0 104.4 236.4 Z',
    'M77 192.7 A128 128 0 0 1 95.1 154.6 L121.4 172.9 A96 96 0 0 0 107.7 201.5 Z',
    'M339.3 130.5 A170 170 0 0 1 363.4 181.1 L332.7 190 A138 138 0 0 0 313 148.8 Z',
    'M365 186.9 A170 170 0 0 1 369.4 242.8 L337.5 240 A138 138 0 0 0 333.9 194.6 Z',
    'M368.7 248.7 A170 170 0 0 1 352.8 302.5 L324 288.5 A138 138 0 0 0 337 244.8 Z',
    'M350.1 307.8 A170 170 0 0 1 315.9 352.3 L294.1 328.9 A138 138 0 0 0 321.8 292.8 Z',
    'M311.5 356.3 A170 170 0 0 1 263.7 385.6 L251.7 356 A138 138 0 0 0 290.5 332.1 Z',
    'M258.1 387.7 A170 170 0 0 1 203 398 L202.4 366 A138 138 0 0 0 247.2 357.7 Z',
    'M197 398 A170 170 0 0 1 141.9 387.7 L152.8 357.7 A138 138 0 0 0 197.6 366 Z',
    'M136.3 385.6 A170 170 0 0 1 88.5 356.3 L109.5 332.1 A138 138 0 0 0 148.3 356 Z',
    'M84.1 352.3 A170 170 0 0 1 49.9 307.8 L78.2 292.8 A138 138 0 0 0 105.9 328.9 Z',
    'M47.2 302.5 A170 170 0 0 1 31.3 248.7 L63 244.8 A138 138 0 0 0 76 288.5 Z',
    'M30.6 242.8 A170 170 0 0 1 35 186.9 L66.1 194.6 A138 138 0 0 0 62.5 240 Z',
    'M36.6 181.1 A170 170 0 0 1 60.7 130.5 L87 148.8 A138 138 0 0 0 67.3 190 Z',
  ];
  const MAP_LABELS = [
    [301, 180], [312, 219], [307, 260], [289, 296], [259, 323], [220, 338],
    [180, 338], [141, 323], [111, 296], [93, 260], [88, 219], [99, 180],
    [339, 162], [354, 216], [348, 272], [322, 322], [280, 359], [228, 379],
    [172, 379], [120, 359], [78, 322], [52, 272], [46, 216], [61, 162],
  ];
  const initialized = new WeakSet();
  const availableSeatCache = new Map();

  function formatMoney(amount, currencySymbol) {
    return `${currencySymbol}${amount.toFixed(2)}`;
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    })[character]);
  }

  function hash(value) {
    let result = 2166136261;
    for (const character of value) {
      result ^= character.charCodeAt(0);
      result = Math.imul(result, 16777619);
    }
    return result >>> 0;
  }

  function availableSeatKeys(categoryId, sector) {
    const key = `${categoryId}:${sector}`;
    if (availableSeatCache.has(key)) return availableSeatCache.get(key);

    const layout = SEAT_LAYOUTS[categoryId] || SEAT_LAYOUTS['upper-tier'];
    const totalSeats = DISPLAYED_CAPACITY[categoryId]?.[sector] || layout.rows.length * layout.seats;
    const allSeats = layout.rows.flatMap((row) =>
      Array.from({ length: layout.seats }, (_, index) => `${row}-${index + 1}`),
    );
    let seed = hash(`${key}:availability`) || 1;
    for (let index = allSeats.length - 1; index > 0; index -= 1) {
      seed ^= seed << 13;
      seed ^= seed >>> 17;
      seed ^= seed << 5;
      seed >>>= 0;
      const swapIndex = seed % (index + 1);
      [allSeats[index], allSeats[swapIndex]] = [allSeats[swapIndex], allSeats[index]];
    }
    const available = new Set(allSeats.slice(0, Math.min(totalSeats, allSeats.length)));
    availableSeatCache.set(key, available);
    return available;
  }

  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);

    const dialog = root.querySelector('[data-jcole-dialog]');
    const dialogContent = root.querySelector('[data-dialog-content]');
    const shareStatus = root.querySelector('[data-share-status]');
    if (!dialog || !dialogContent) return;

    const categories = [...root.querySelectorAll('[data-ticket-category]')];
    const eventDateOptions = [...root.querySelectorAll('[data-event-date-option]')];
    const selectedEventDateLabel = root.querySelector('[data-selected-event-date-label]');
    const currencySymbol = root.dataset.currencySymbol || '£';
    const fanKitText = root.dataset.fanKitText || 'Exclusive fan kit: official T-shirt and personalised cup';
    const floorQuantities = new Map();
    let picker = null;
    let checkoutPending = false;

    function track(eventType, details = {}) {
      document.dispatchEvent(new CustomEvent('ticketmaker:analytics', {
        detail: {
          eventType,
          eventName: root.dataset.eventTitle || document.title,
          ...details,
        },
      }));
    }

    function selectEventDate(selectedOption) {
      eventDateOptions.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', String(isSelected));
      });

      const selectedDateLabel = selectedOption.dataset.eventDateLabel || '';
      root.dataset.selectedEventDate = selectedDateLabel;
      if (selectedEventDateLabel) selectedEventDateLabel.textContent = selectedDateLabel;
    }

    eventDateOptions.forEach((option) => {
      option.addEventListener('click', () => selectEventDate(option));
    });
    if (eventDateOptions.length) {
      selectEventDate(
        eventDateOptions.find((option) => option.getAttribute('aria-pressed') === 'true')
          || eventDateOptions[0],
      );
    }

    const selectedCount = () =>
      [...floorQuantities.values()].reduce((total, count) => total + count, 0);

    function variantIdFor(category) {
      return (category?.dataset.variantId || '').trim();
    }

    function ensureCheckoutError() {
      if (dialog.open) {
        let errorElement = dialogContent.querySelector('[data-checkout-error]');
        if (!errorElement) {
          errorElement = document.createElement('p');
          errorElement.className = 'jcole-checkout-error';
          errorElement.dataset.checkoutError = '';
          errorElement.setAttribute('role', 'alert');
          errorElement.hidden = true;
          dialogContent.querySelector('.jcole-dialog__footer')?.prepend(errorElement);
        }
        if (errorElement?.isConnected) return errorElement;
      }

      let errorElement = root.querySelector('[data-global-checkout-error]');
      if (!errorElement) {
        errorElement = document.createElement('p');
        errorElement.className = 'jcole-checkout-error';
        errorElement.dataset.globalCheckoutError = '';
        errorElement.setAttribute('role', 'alert');
        errorElement.hidden = true;
        root.querySelector('.jcole-ticket-table')?.insertAdjacentElement('afterend', errorElement);
      }
      return errorElement;
    }

    function setCheckoutError(message) {
      const errorElement = ensureCheckoutError();
      if (!errorElement) return;
      errorElement.textContent = message;
      errorElement.hidden = !message;
    }

    function makeCartItem(category, quantity) {
      const rawVariantId = variantIdFor(category);
      const variantId = Number(rawVariantId);
      if (!/^\d+$/.test(rawVariantId) || !Number.isSafeInteger(variantId) || variantId <= 0) {
        throw new Error(`Add a valid Shopify variant ID for ${category?.dataset.name || 'this ticket'} in its ticket block settings.`);
      }

      return { id: rawVariantId, quantity };
    }

    function cartUrlFor(items) {
      let storeUrl;
      try {
        storeUrl = new URL((root.dataset.cartStoreUrl || '').trim());
      } catch {
        throw new Error('Set the destination Shopify cart store URL in this event section settings.');
      }
      if (
        storeUrl.protocol !== 'https:'
        || !storeUrl.hostname.endsWith('.myshopify.com')
        || storeUrl.pathname !== '/'
        || storeUrl.search
        || storeUrl.hash
      ) {
        throw new Error('The cart store URL must be an HTTPS myshopify.com store domain.');
      }
      const cartLines = items.map((item) => `${item.id}:${item.quantity}`).join(',');
      return `${storeUrl.origin}/cart/${cartLines}`;
    }

    function buildCartItems(seatOrder = null) {
      const items = [];
      categories.forEach((category) => {
        const quantity = floorQuantities.get(category.dataset.categoryId) || 0;
        if (quantity > 0) items.push(makeCartItem(category, quantity));
      });

      if (seatOrder?.seats?.length) {
        items.push(makeCartItem(seatOrder.category, seatOrder.seats.length));
      }

      const quantity = items.reduce((total, item) => total + item.quantity, 0);
      if (quantity < 1) throw new Error('Choose at least one ticket before continuing to checkout.');
      if (quantity > MAX_TICKETS) throw new Error(`A maximum of ${MAX_TICKETS} tickets can be checked out at once.`);
      return items;
    }

    function addQuantityCheckoutControls() {
      categories.forEach((category) => {
        if (category.dataset.selectionMode !== 'quantity') return;
        const quantityControl = category.querySelector('[data-quantity-control]');
        if (!quantityControl || category.querySelector('[data-checkout-quantity]')) return;

        const actions = document.createElement('div');
        actions.className = 'jcole-quantity-actions';
        quantityControl.parentNode.insertBefore(actions, quantityControl);
        actions.append(quantityControl);

        const checkoutButton = document.createElement('button');
        checkoutButton.type = 'button';
        checkoutButton.className = 'jcole-seat-button jcole-quantity-checkout';
        checkoutButton.dataset.checkoutQuantity = '';
        checkoutButton.disabled = true;
        checkoutButton.textContent = 'Continue to cart';
        actions.append(checkoutButton);
      });
    }

    async function recordCheckoutLead(seatOrder, items) {
      const endpoint = (root.dataset.leadApiUrl || '').trim();
      if (!endpoint) return;
      const selectedCategories = categories.filter((category) => {
        if (seatOrder?.category === category) return true;
        return (floorQuantities.get(category.dataset.categoryId) || 0) > 0;
      });

      let calculatedPrice = 0;
      selectedCategories.forEach((category) => {
        const qty = seatOrder?.category === category
          ? (seatOrder.seats?.length || 1)
          : (floorQuantities.get(category.dataset.categoryId) || 0);
        const priceEl = category.querySelector('.jcole-ticket-table__price b') || category.querySelector('.jcole-ticket-table__price');
        const num = parseFloat((priceEl?.textContent || '').replace(/[^0-9.]/g, '')) || 0;
        calculatedPrice += num * qty;
      });

      const currencySym = root.dataset.currencySymbol || '$';
      const formattedPrice = calculatedPrice > 0 ? `${currencySym}${calculatedPrice.toFixed(2)}` : null;

      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 1800);
      try {
        await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            event: root.dataset.eventTitle || document.title,
            eventHandle: root.dataset.eventHandle || window.location.pathname,
            ticketType: selectedCategories.map((category) => category.dataset.name || category.querySelector('.jcole-ticket-table__title b')?.textContent?.trim() || 'Ingresso').join(' + '),
            variantId: items.map((item) => item.id).join(','),
            quantity: items.reduce((total, item) => total + item.quantity, 0),
            block: seatOrder?.sector || 'Geral',
            seats: seatOrder?.seats || [],
            price: formattedPrice,
            currencySymbol: currencySym,
            sourceUrl: window.location.href,
            clickedAt: new Date().toISOString()
          }),
          signal: controller.signal,
        });
      } catch {
        // Tracking must never prevent the buyer from reaching Shopify checkout.
      } finally {
        window.clearTimeout(timeout);
      }
    }

    async function openShopifyCart(button, seatOrder = null) {
      if (checkoutPending) return;

      let items;
      let cartUrl;
      try {
        items = buildCartItems(seatOrder);
        cartUrl = cartUrlFor(items);
      } catch (error) {
        setCheckoutError(error.message || 'Could not prepare these tickets for checkout.');
        return;
      }

      const originalLabel = button.textContent;
      checkoutPending = true;
      setCheckoutError('');
      dialog.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = 'Opening ticket cart…';
      refreshQuantityControls();

      await recordCheckoutLead(seatOrder, items);
      window.location.assign(cartUrl);
    }

    function refreshQuantityControls() {
      categories.forEach((category) => {
        if (category.dataset.selectionMode !== 'quantity') {
          const seatButton = category.querySelector('[data-open-seat-picker]');
          if (seatButton) {
            seatButton.disabled = checkoutPending || selectedCount() >= MAX_TICKETS;
          }
          return;
        }
        const count = floorQuantities.get(category.dataset.categoryId) || 0;
        const value = category.querySelector('[data-quantity-value]');
        const minus = category.querySelector('[data-quantity-minus]');
        const plus = category.querySelector('[data-quantity-plus]');
        const checkoutButton = category.querySelector('[data-checkout-quantity]');
        if (value) value.textContent = String(count);
        if (minus) minus.disabled = checkoutPending || count === 0;
        if (plus) plus.disabled = checkoutPending || selectedCount() >= MAX_TICKETS;
        if (checkoutButton) {
          checkoutButton.disabled = checkoutPending || count === 0;
          checkoutButton.textContent = checkoutPending ? 'Opening ticket cart…' : 'Continue to cart';
        }
      });
      const confirmButton = dialogContent.querySelector('[data-confirm-seats]');
      if (confirmButton) {
        confirmButton.disabled = checkoutPending || !picker?.seats.length;
        if (checkoutPending) confirmButton.textContent = 'Opening ticket cart…';
      }
    }

    function categorySectors(category) {
      const sectors = (category.dataset.sectors || '')
        .split(',')
        .map((sector) => sector.trim().toUpperCase())
        .filter((sector) => /^[0-9]{1,2}[LU]$/.test(sector));
      return sectors.length
        ? sectors
        : (FALLBACK_SECTORS[category.dataset.categoryId] || FALLBACK_SECTORS['upper-tier']);
    }

    function sectorLabel(sector) {
      return `${sector.endsWith('U') ? 'Upper' : 'Lower'} Tier · Block ${sector.replace(/[LU]$/, '')}`;
    }

    function showDialog() {
      if (!dialog.open) dialog.showModal();
    }

    function closePicker() {
      if (checkoutPending) return;
      picker = null;
      dialogContent.replaceChildren();
      if (dialog.open) dialog.close();
    }

    function mapMarkup(sectors, selectedSector) {
      const available = new Set(sectors);
      return `
        <div class="jcole-seat-map" aria-label="Arena seating map">
          <img src="${escapeHtml(mapUrl)}" alt="Arena seat map" width="400" height="420">
          <svg viewBox="0 0 400 420" role="group" aria-label="Choose an available arena block">
            ${MAP_SECTOR_PATHS.map((path, index) => {
              const sector = `${(index % 12) + 1}${index < 12 ? 'L' : 'U'}`;
              const enabled = available.has(sector);
              const [x, y] = MAP_LABELS[index];
              return `
                <g class="jcole-map-sector" data-map-sector="${sector}" role="button"
                  tabindex="${enabled ? '0' : '-1'}" aria-disabled="${!enabled}"
                  aria-pressed="${selectedSector === sector}" aria-label="${sector}${enabled ? ', available' : ', unavailable'}">
                  <path d="${path}" fill="${enabled ? '#60a5fa' : '#e5e7eb'}"
                    stroke="${selectedSector === sector ? '#1d4ed8' : '#ffffff'}"
                    stroke-width="${selectedSector === sector ? '3' : '2'}"></path>
                  <path d="${path}" fill="none" stroke="transparent" stroke-width="22"></path>
                  <text x="${x}" y="${y}" fill="${enabled ? '#ffffff' : '#374151'}">${(index % 12) + 1}</text>
                </g>
              `;
            }).join('')}
          </svg>
        </div>
      `;
    }

    function renderSectorPicker() {
      const category = picker.category;
      const sectors = categorySectors(category);
      const bestSector = sectors[0] || '';
      const selectedSector = picker.sector;
      const feeDisplay = category.dataset.feeDisplay || 'Fees included';
      const price = category.dataset.price || '';
      dialogContent.innerHTML = `
        <section class="jcole-dialog__panel" aria-labelledby="jcole-dialog-title">
          <header class="jcole-dialog__header">
            <button type="button" data-dialog-close aria-label="Close seat picker">×</button>
            <div class="jcole-dialog__heading">
              <strong id="jcole-dialog-title">${escapeHtml(category.dataset.name)}</strong>
              <small>${escapeHtml(price)} · ${escapeHtml(feeDisplay)} · + ${escapeHtml(fanKitText)}</small>
            </div>
            <button type="button" class="jcole-best-button" data-best-sector="${escapeHtml(bestSector)}" ${bestSector ? '' : 'disabled'}>Best available</button>
          </header>
          <div class="jcole-dialog__scroll">
            ${mapMarkup(sectors, selectedSector)}
            <div class="jcole-sector-list">
              ${sectors.map((sector) => `
                <button type="button" class="jcole-sector-row ${selectedSector === sector ? 'is-selected' : ''}"
                  data-select-sector="${sector}" aria-pressed="${selectedSector === sector}">
                  <span class="jcole-sector-row__dot"></span>
                  <strong>${escapeHtml(sectorLabel(sector))}</strong>
                  <small>${DISPLAYED_CAPACITY[category.dataset.categoryId]?.[sector] || 'Available'} seats</small>
                </button>
              `).join('')}
            </div>
            ${sectors.length ? '' : '<p role="status">No numbered-seat blocks are configured for this category.</p>'}
          </div>
          <footer class="jcole-dialog__footer">
            <button type="button" class="jcole-choose-seats" data-continue-seats ${selectedSector ? '' : 'disabled'}>Select your seats</button>
          </footer>
        </section>
      `;
      showDialog();
    }

    function renderSeatPicker() {
      const category = picker.category;
      const layout = SEAT_LAYOUTS[category.dataset.categoryId] || SEAT_LAYOUTS['upper-tier'];
      const remaining = MAX_TICKETS - selectedCount();
      const available = availableSeatKeys(category.dataset.categoryId, picker.sector);
      const price = Number.parseFloat((category.dataset.price || '').replace(/[^\d.]/g, '')) || 0;
      const blockTitle = sectorLabel(picker.sector);
      dialogContent.innerHTML = `
        <section class="jcole-dialog__panel" aria-labelledby="jcole-dialog-title">
          <header class="jcole-dialog__header">
            <button type="button" data-dialog-back aria-label="Back to arena map">‹</button>
            <div class="jcole-dialog__heading">
              <strong id="jcole-dialog-title">${escapeHtml(blockTitle)}</strong>
              <small>${escapeHtml(category.dataset.name)} · ${escapeHtml(category.dataset.price)} · ${escapeHtml(category.dataset.feeDisplay || 'Fees included')} · + ${escapeHtml(fanKitText)}</small>
            </div>
            <button type="button" class="jcole-dialog__close" data-dialog-close aria-label="Close seat selection">×</button>
          </header>
          <div class="jcole-dialog__scroll">
            <div class="jcole-seat-direction">Front of block (towards the stage)</div>
            <p class="jcole-seat-limit">Maximum ${MAX_TICKETS} tickets per order · ${remaining} remaining</p>
            <div class="jcole-seat-grid-viewport">
              <div class="jcole-seat-grid" role="group" aria-label="Seats in ${escapeHtml(blockTitle)}">
                ${layout.rows.map((row) => `
                  <div class="jcole-seat-row" style="--jcole-seat-count:${layout.seats}">
                    <span class="jcole-seat-row__label">${row}</span>
                    ${Array.from({ length: layout.seats }, (_, index) => {
                      const number = index + 1;
                      const seat = `${row}-${number}`;
                      const isAvailable = available.has(seat);
                      const selected = picker.seats.includes(seat);
                      const selectionLimitReached = picker.seats.length >= remaining;
                      const disabled = !selected && (!isAvailable || remaining <= 0 || selectionLimitReached);
                      return `<button type="button" class="jcole-seat ${isAvailable ? 'is-available' : 'is-unavailable'} ${selected ? 'is-selected' : ''}"
                        data-seat="${seat}" aria-pressed="${selected}" aria-label="Row ${row}, seat ${number}${isAvailable ? ', available' : ', unavailable'}"
                        ${disabled ? 'disabled' : ''}>${number}</button>`;
                    }).join('')}
                  </div>
                `).join('')}
              </div>
            </div>
            ${picker.seats.length ? `
              <div class="jcole-selected-seats" aria-label="Selected seats">
                ${picker.seats.map((seat) => `
                  <div class="jcole-selected-chip"><span>${escapeHtml(blockTitle)} · Row ${seat.split('-')[0]} · Seat ${seat.split('-')[1]}</span>
                    <button type="button" data-remove-draft-seat="${seat}" aria-label="Remove ${seat}">×</button>
                  </div>
                `).join('')}
              </div>
            ` : ''}
          </div>
          <footer class="jcole-dialog__footer">
            <p class="jcole-checkout-error" data-checkout-error role="alert" hidden></p>
            <button type="button" class="jcole-choose-seats" data-confirm-seats ${picker.seats.length ? '' : 'disabled'}>
              ${picker.seats.length
                ? `Confirm ${picker.seats.length} seat${picker.seats.length === 1 ? '' : 's'} · ${formatMoney(price * picker.seats.length, currencySymbol)}`
                : 'Select your seats'}
            </button>
          </footer>
        </section>
      `;
      showDialog();
    }

    const seatData = root.querySelector('[data-jcole-seat-data]');
    let mapUrl = '';
    try {
      mapUrl = JSON.parse(seatData?.textContent || '{}').sections?.arenaMap || '';
    } catch (error) {
      console.error('Event page: could not read the arena map asset URL.', error);
    }

    root.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target || checkoutPending) return;

      const categoryToggle = target.closest('[data-category-toggle]');
      if (categoryToggle) {
        const category = categoryToggle.closest('[data-ticket-category]');
        if (!category) return;
        const offers = category.querySelector('[data-category-offers]');
        const willOpen = categoryToggle.getAttribute('aria-expanded') !== 'true';
        categories.forEach((item) => {
          const toggle = item.querySelector('[data-category-toggle]');
          const panel = item.querySelector('[data-category-offers]');
          if (toggle) toggle.setAttribute('aria-expanded', item === category && willOpen ? 'true' : 'false');
          if (panel) panel.hidden = item !== category || !willOpen;
        });
        if (willOpen) {
          track('ticket_open', { ticketType: category.dataset.name });
        }
        return;
      }

      const quantityButton = target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (quantityButton) {
        const category = quantityButton.closest('[data-ticket-category]');
        const id = category?.dataset.categoryId;
        if (!category || !id) return;
        const current = floorQuantities.get(id) || 0;
        if (quantityButton.hasAttribute('data-quantity-minus')) {
          floorQuantities.set(id, Math.max(0, current - 1));
        } else if (selectedCount() < MAX_TICKETS) {
          floorQuantities.set(id, Math.min(MAX_TICKETS, current + 1));
        }
        setCheckoutError('');
        refreshQuantityControls();
        return;
      }

      const quantityCheckoutButton = target.closest('[data-checkout-quantity]');
      if (quantityCheckoutButton) {
        openShopifyCart(quantityCheckoutButton);
        return;
      }

      if (target.closest('[data-open-seat-picker]')) {
        const category = target.closest('[data-ticket-category]');
        if (!category) return;
        if (selectedCount() >= MAX_TICKETS) {
          setCheckoutError(`A maximum of ${MAX_TICKETS} tickets can be checked out at once.`);
          return;
        }
        picker = { category, stage: 'sectors', sector: null, seats: [] };
        track('seat_picker_open', { ticketType: category.dataset.name });
        renderSectorPicker();
        return;
      }

      const chooseSector = target.closest('[data-select-sector], [data-map-sector]');
      if (chooseSector && picker?.stage === 'sectors') {
        const sector = chooseSector.dataset.selectSector || chooseSector.dataset.mapSector;
        if (categorySectors(picker.category).includes(sector)) {
          picker.sector = sector;
          track('block_selected', {
            ticketType: picker.category.dataset.name,
            block: sector,
          });
          renderSectorPicker();
        }
        return;
      }

      if (target.closest('[data-best-sector]') && picker?.stage === 'sectors') {
        picker.sector = target.closest('[data-best-sector]').dataset.bestSector;
        renderSectorPicker();
        return;
      }

      if (target.closest('[data-continue-seats]') && picker?.stage === 'sectors' && picker.sector) {
        picker.stage = 'seats';
        picker.seats = [];
        renderSeatPicker();
        return;
      }

      const seatButton = target.closest('[data-seat]');
      if (seatButton && picker?.stage === 'seats' && !seatButton.disabled) {
        const seat = seatButton.dataset.seat;
        picker.seats = picker.seats.includes(seat)
          ? picker.seats.filter((item) => item !== seat)
          : [...picker.seats, seat];
        renderSeatPicker();
        return;
      }

      const removeDraftSeat = target.closest('[data-remove-draft-seat]');
      if (removeDraftSeat && picker?.stage === 'seats') {
        picker.seats = picker.seats.filter((seat) => seat !== removeDraftSeat.dataset.removeDraftSeat);
        renderSeatPicker();
        return;
      }

      if (target.closest('[data-dialog-back]') && picker) {
        picker.stage = 'sectors';
        picker.seats = [];
        renderSectorPicker();
        return;
      }

      if (target.closest('[data-confirm-seats]') && picker?.stage === 'seats' && picker.seats.length) {
        track('seats_selected', {
          ticketType: picker.category.dataset.name,
          block: picker.sector,
          seatCount: picker.seats.length,
        });
        openShopifyCart(target.closest('[data-confirm-seats]'), {
          category: picker.category,
          sector: picker.sector,
          seats: [...picker.seats],
        });
        return;
      }

      if (target.closest('[data-dialog-close]')) {
        closePicker();
        return;
      }

      if (target.closest('[data-share-event]')) {
        const share = async () => {
          const url = window.location.href;
          try {
            if (navigator.share) {
              await navigator.share({ title: root.querySelector('h1')?.textContent?.trim() || document.title, url });
              if (shareStatus) shareStatus.textContent = 'Link shared.';
            } else if (navigator.clipboard?.writeText) {
              await navigator.clipboard.writeText(url);
              if (shareStatus) shareStatus.textContent = 'Link copied.';
            } else {
              const input = document.createElement('textarea');
              input.value = url;
              input.setAttribute('readonly', '');
              input.style.position = 'fixed';
              input.style.opacity = '0';
              document.body.append(input);
              input.select();
              const copied = document.execCommand('copy');
              input.remove();
              if (shareStatus) shareStatus.textContent = copied ? 'Link copied.' : 'Copy this page URL to share.';
            }
          } catch (error) {
            if (error?.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Could not share this link.';
          }
          window.setTimeout(() => { if (shareStatus) shareStatus.textContent = ''; }, 3500);
        };
        share();
        return;
      }
    });

    root.addEventListener('keydown', (event) => {
      const sector = event.target instanceof Element ? event.target.closest('[data-map-sector]') : null;
      if (sector && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        sector.click();
      }
      if (event.key === 'Escape' && dialog.open && !checkoutPending) closePicker();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog && !checkoutPending) closePicker();
    });
    dialog.addEventListener('close', () => {
      picker = null;
      dialogContent.replaceChildren();
    });

    addQuantityCheckoutControls();
    refreshQuantityControls();
  }

  function initializeAll(scope = document) {
    if (scope.matches?.('[data-jcole-event]')) initialize(scope);
    scope.querySelectorAll?.('[data-jcole-event]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();